module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-input-tag input-tag-wrapper",
    class: [_vm.size ? 'el-input-tag--' + _vm.size : ''],
    on: {
      "click": _vm.foucusTagInput
    }
  }, [_vm._l((_vm.innerTags), function(tag, idx) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "size": _vm.size,
        "closable": !_vm.readOnly,
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.remove(idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    staticClass: "tag-input",
    attrs: {
      "size": _vm.size
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        $event.stopPropagation();
        return _vm.removeLastTag($event)
      }, _vm.addNew],
      "blur": _vm.addNew,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449eea92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/el-input-tag/src/ElInputTag.vue
// module id = 3255
// module chunks = 3